import React, { useEffect, useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Textarea } from '../components/ui/textarea';
import Navigation from '../components/Navigation';
import { getAuthHeaders } from '../lib/auth';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Strategy() {
  const [items, setItems] = useState([]);
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);

  const loadNotes = async () => {
    try {
      const response = await axios.get(`${API}/strategy`, {
        headers: getAuthHeaders()
      });
      setItems(response.data);
    } catch (error) {
      console.error('Failed to load strategy notes:', error);
    }
  };

  useEffect(() => {
    loadNotes();
  }, []);

  const addNote = async () => {
    if (!note.trim()) {
      toast.error('Please enter a strategy note');
      return;
    }

    try {
      setLoading(true);
      await axios.post(
        `${API}/strategy`,
        null,
        {
          params: { note },
          headers: getAuthHeaders()
        }
      );
      setNote('');
      toast.success('Strategy note saved');
      loadNotes();
    } catch (error) {
      console.error('Failed to add note:', error);
      toast.error('Failed to save note');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <div className="p-6 space-y-6 max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-orange-600 to-red-600 flex items-center justify-center">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
            </svg>
          </div>
          <div>
            <h1 className="text-3xl font-bold text-gray-900">Strategy</h1>
            <p className="text-gray-600">Document your business strategies</p>
          </div>
        </div>

        <Card className="max-w-2xl">
          <CardHeader>
            <CardTitle>Add Strategy Note</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <Textarea 
              placeholder="Write your strategy note here..." 
              value={note} 
              onChange={(e) => setNote(e.target.value)} 
              rows={4}
            />
            <Button onClick={addNote} disabled={loading}>
              {loading ? 'Saving...' : 'Save Note'}
            </Button>
          </CardContent>
        </Card>

        <div className="grid gap-3 max-w-2xl">
          {items.length === 0 ? (
            <Card>
              <CardContent className="p-6 text-center text-gray-500">
                No strategy notes yet. Add your first note above.
              </CardContent>
            </Card>
          ) : (
            items.map(s => (
              <Card key={s.id}>
                <CardContent className="p-4">
                  <div className="text-xs text-gray-500 mb-2">
                    {new Date(s.createdAt).toLocaleString()}
                  </div>
                  <p className="text-sm text-gray-700 whitespace-pre-wrap">{s.note}</p>
                </CardContent>
              </Card>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
